import * as types from '../types/authTypes';
import authService from '../../services/authService';

// Action pour se connecter
export const login = (credentials) => async (dispatch) => {
  try {
    dispatch({ type: types.LOGIN_REQUEST });
    
    const response = await authService.login(credentials);
    
    // Stocker le token dans le localStorage
    localStorage.setItem('token', response.token);
    
    dispatch({
      type: types.LOGIN_SUCCESS,
      payload: response
    });
    
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: types.LOGIN_FAILURE,
      payload: error.response?.data?.message || 'Erreur de connexion'
    });
    
    return Promise.reject(error);
  }
};

// Action pour s'inscrire
export const register = (userData) => async (dispatch) => {
  try {
    dispatch({ type: types.REGISTER_REQUEST });

    const response = await authService.register(userData);

    if (response.requiresVerification) {
      dispatch({ type: types.REGISTER_PENDING_VERIFICATION, payload: response });
    } else {
      localStorage.setItem('token', response.token);
      dispatch({ type: types.REGISTER_SUCCESS, payload: response });
    }

    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: types.REGISTER_FAILURE,
      payload: error.response?.data?.message || 'Erreur d\'inscription'
    });

    return Promise.reject(error);
  }
};

// Action pour se déconnecter
export const logout = () => (dispatch) => {
  // Supprimer le token du localStorage
  localStorage.removeItem('token');
  
  dispatch({ type: types.LOGOUT });
};

// Action pour vérifier l'email
export const verifyEmail = (token) => async (dispatch) => {
  try {
    dispatch({ type: types.VERIFY_EMAIL_REQUEST });
    
    const response = await authService.verifyEmail(token);
    
    dispatch({
      type: types.VERIFY_EMAIL_SUCCESS,
      payload: response
    });
    
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: types.VERIFY_EMAIL_FAILURE,
      payload: error.response?.data?.message || 'Erreur de vérification de l\'email'
    });
    
    return Promise.reject(error);
  }
};

// Action pour demander une réinitialisation de mot de passe
export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: types.FORGOT_PASSWORD_REQUEST });
    
    const response = await authService.forgotPassword(email);
    
    dispatch({
      type: types.FORGOT_PASSWORD_SUCCESS,
      payload: response
    });
    
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: types.FORGOT_PASSWORD_FAILURE,
      payload: error.response?.data?.message || 'Erreur de demande de réinitialisation'
    });
    
    return Promise.reject(error);
  }
};

// Action pour réinitialiser le mot de passe
export const resetPassword = (data) => async (dispatch) => {
  try {
    dispatch({ type: types.RESET_PASSWORD_REQUEST });
    
    const response = await authService.resetPassword(data);
    
    dispatch({
      type: types.RESET_PASSWORD_SUCCESS,
      payload: response
    });
    
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: types.RESET_PASSWORD_FAILURE,
      payload: error.response?.data?.message || 'Erreur de réinitialisation du mot de passe'
    });
    
    return Promise.reject(error);
  }
};

// Action pour mettre à jour le profil
export const updateProfile = (userData) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_PROFILE_REQUEST });
    
    const response = await authService.updateProfile(userData);
    
    dispatch({
      type: types.UPDATE_PROFILE_SUCCESS,
      payload: response
    });
    
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: types.UPDATE_PROFILE_FAILURE,
      payload: error.response?.data?.message || 'Erreur de mise à jour du profil'
    });
    
    return Promise.reject(error);
  }
};

// Action pour changer le mot de passe
export const changePassword = (passwords) => async (dispatch) => {
  try {
    dispatch({ type: types.CHANGE_PASSWORD_REQUEST });
    
    const response = await authService.changePassword(passwords);
    
    dispatch({
      type: types.CHANGE_PASSWORD_SUCCESS,
      payload: response
    });
    
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: types.CHANGE_PASSWORD_FAILURE,
      payload: error.response?.data?.message || 'Erreur de changement de mot de passe'
    });
    
    return Promise.reject(error);
  }
};

// Action pour vérifier si l'utilisateur est authentifié
export const checkAuth = () => async (dispatch) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    dispatch({ type: types.AUTH_CHECK_FAILURE });
    return;
  }
  
  try {
    dispatch({ type: types.AUTH_CHECK_REQUEST });
    
    const response = await authService.getProfile();
    
    dispatch({
      type: types.AUTH_CHECK_SUCCESS,
      payload: response
    });
    
    return Promise.resolve(response);
  } catch (error) {
    // Si le token est invalide ou expiré, le supprimer
    localStorage.removeItem('token');
    
    dispatch({
      type: types.AUTH_CHECK_FAILURE,
      payload: error.response?.data?.message || 'Session expirée'
    });
    
    return Promise.reject(error);
  }
};

// Action pour effacer les erreurs d'authentification
export const clearAuthError = () => ({
  type: types.CLEAR_AUTH_ERROR
});
// Actions pour les préférences de notifications email
export const fetchEmailNotifications = () => async (dispatch) => {
  try {
    dispatch({ type: types.FETCH_EMAIL_NOTIFICATIONS_REQUEST });
    const response = await authService.getEmailNotifications();
    dispatch({ type: types.FETCH_EMAIL_NOTIFICATIONS_SUCCESS, payload: response.emailNotifications });
    return Promise.resolve(response.emailNotifications);
  } catch (error) {
    dispatch({ type: types.FETCH_EMAIL_NOTIFICATIONS_FAILURE, payload: error.response?.data?.message || 'Erreur' });
    return Promise.reject(error);
  }
};

export const updateEmailNotifications = (emailNotifications) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_EMAIL_NOTIFICATIONS_REQUEST });
    const response = await authService.updateEmailNotifications(emailNotifications);
    dispatch({ type: types.UPDATE_EMAIL_NOTIFICATIONS_SUCCESS, payload: response.emailNotifications });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: types.UPDATE_EMAIL_NOTIFICATIONS_FAILURE, payload: error.response?.data?.message || 'Erreur' });
    return Promise.reject(error);
  }
};

export const fetchVacations = () => async (dispatch) => {
  try {
    dispatch({ type: types.FETCH_VACATIONS_REQUEST });
    const response = await authService.getVacations();
    dispatch({ type: types.FETCH_VACATIONS_SUCCESS, payload: response.vacations });
    return Promise.resolve(response.vacations);
  } catch (error) {
    dispatch({ type: types.FETCH_VACATIONS_FAILURE, payload: error.response?.data?.message || 'Erreur' });
    return Promise.reject(error);
  }
};

export const createVacation = (vacation) => async (dispatch) => {
  try {
    dispatch({ type: types.CREATE_VACATION_REQUEST });
    const response = await authService.createVacation(vacation);
    dispatch({ type: types.CREATE_VACATION_SUCCESS, payload: response.vacation });
    return Promise.resolve(response.vacation);
  } catch (error) {
    dispatch({ type: types.CREATE_VACATION_FAILURE, payload: error.response?.data?.message || 'Erreur' });
    return Promise.reject(error);
  }
};

export const updateVacation = (id, vacation) => async (dispatch) => {
  try {
    dispatch({ type: types.UPDATE_VACATION_REQUEST });
    const response = await authService.updateVacation(id, vacation);
    dispatch({ type: types.UPDATE_VACATION_SUCCESS, payload: response.vacation });
    return Promise.resolve(response.vacation);
  } catch (error) {
    dispatch({ type: types.UPDATE_VACATION_FAILURE, payload: error.response?.data?.message || 'Erreur' });
    return Promise.reject(error);
  }
};

export const deleteVacation = (id) => async (dispatch) => {
  try {
    dispatch({ type: types.DELETE_VACATION_REQUEST });
    await authService.deleteVacation(id);
    dispatch({ type: types.DELETE_VACATION_SUCCESS, payload: id });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: types.DELETE_VACATION_FAILURE, payload: error.response?.data?.message || 'Erreur' });
    return Promise.reject(error);
  }
};
